import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/* Component */
import FormComponent from 'components/FormComponent';

/* API */
import TenpoService from 'api/TenpoService';
import { TenpoResponseDto as TenpoType } from 'api/generated/openapi';

/* Layout */
import Layout from 'layout/Layout';
import LoadingSpinner from 'util/LoadingSpinner';

/* Context */
import { TenpoContext } from 'context/TenpoContext';

const FormPage: React.FC = () => {
  const { tenpoCode } = useParams(); // TODO: 予約タイプ取得のAPIパラメーターに使う
  const [tenpo, setTenpo] = useState<TenpoType | any>();
  const [isLoading, setIsLoading] = useState(true);
  const titleSuffix = 'web予約';
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTenpo = async () => {
      try {
        const result = await TenpoService.get({ tenpoCode: tenpoCode ?? '' });
        setTenpo(result);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };
    fetchTenpo();
  }, []);

  const pageTitle = `${tenpo?.tenpoName} ` + titleSuffix;

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!tenpo?.tenpoName) {
    navigate('/404');
  }

  return (
    <TenpoContext.Provider value={tenpo}>
      <Layout pageTitle={pageTitle}>
        <FormComponent></FormComponent>
      </Layout>
    </TenpoContext.Provider>
  );
};
export default FormPage;
